const en = {
    create_shipment: "Create Shipment",
    home: "Home",
    tracking_parcel: "Tracking Parcel",
    my_labels: "My Labels",
    shop: "Shop",
    logout: "Logout",

    "total_parcels": "Total Parcels",
    "delivered_parcels": "Delivered Parcels",
    "pending_parcels": "Pending Parcels",
    "return_parcels": "Return Parcels",
    "track_id_placeholder": "Add Your Track ID Here",

    "find_the_most_affordable_courier_service": "Find the most affordable Courier Service",


    "parcel_name": "Parcel Name",
    "item_name": "Item Name",
    "tracking_id": "Tracking ID",
    "courier_service": "Courier Service",
    "ship_location": "Ship Location",
    "delivery_date": "Delivery Date",
    "parcel_details": "Parcel Details",
    "status": "Status",
    "paid_amount": "Paid Amount",
    "from": "From",
    "to": "To",
    "download": "Download",
    "print": "Print",

    "find_most_affordable_courier_service": "Find the most affordable Courier Service",
    "transaction_history": "Transaction History",

    "discover": "Discover",
    "best_selling_products_weekly_update": "Best Selling Products - Weekly Update.",

    "all": "All",
    "cartons_and_boxes": "Cartons & boxes",
    "shipping_packaging": "Shipping Packaging",
    "format_and_rolls": "Format & Rolls",
    "tape_and_dispensers": "Tape & Dispensers",
    "packing_accessories": "Packing Accessories",

    "legal": "Legal",
    "terms_of_use": "Terms of Use",
    "privacy_statement": "Privacy Statement",
    "about_us": "About Us",
    "test_text": `There are many variations of passages of Lorem Ipsum available, but the majority have suffered alteration in some form, The point of using Lorem Ipsum is that it has a more-or-less normal distribution of letters, as opposed to using 'Content here, There are many variations of passages of Lorem Ipsum available, but the majority have suffered alteration in some form, The point of using Lorem Ipsum is that it has a more-or-less normal distribution of letters, as opposed to using 'Content he`,

    "back": "Back",
    "continue": "Continue",
    "next": "Next",
    "submit": "Submit",
    "done": "Done",
    "pay": "Pay",

    "premium_hand_dispenser": "Premium hand dispenser for adhesive tapes up to 50 mm tape width | safety knife",
    "item": "Item",
    "unit_price_excluding_vat": "Unit price excluding VAT",
    "unit_price_including_vat": "Unit price including VAT",
    "from_15_pcs_each": "From 15 pcs. each",
    "quantity": "Quantity",
    "add_to_cart": "Add To Cart",
    "delivery_time": "Delivery Time",
    "parcel_shipping": "Parcel shipping 2-3 Working days / Pallet shipping 3-5 Working days",
    "best_selling_products": "Best Selling Products",
    "bubble_wrap": "Bubble wrap made of paper two-ply 350mm width x 5 running meters brown TEST QUANTITY",

    "order_summary": "Order Summary",
    "shipping": "Shipping",
    "delivery": "Delivery",
    "payment": "Payment",
    "shipping_details": "Shipping Details",
    "subtotal": "Subtotal",
    "sales_tax": "Sales tax",
    "shipping_fee": "Shipping Fee",
    "total_due": "Total Due",
    "free": "FREE",
    "my_shipping_and_billing_address_are_the_same": "My shipping and Billing address are the same",

    "delivery_options": "Delivery Options",
    "standard_5_7_business_days": "Standard 5-7 Business Days",
    "business_days": "2-4 Business Days",
    "same_day_delivery": "Same day delivery",

    "payment_methods": "Payment Methods",
    "pay_on_delivery": "Pay on Delivery",
    "pay_with_cash_on_delivery": "Pay with cash on delivery",
    "credit_debit_cards": "Credit/Debit Cards",
    "pay_with_credit_debit_card": "Pay with your Credit / Debit Card",
    "direct_bank_transfer": "Direct Bank Transfer",
    "make_payment_through_bank": "Make payment directly through bank account.",

    "other_payment_methods": "Other Payment Methods",
    "make_payment_through": "Make payment through Gpay, Paypal, Paytm etc,",

    "select_courier_service": "Select Courier Service",
    "view_all": "View all",
    "less_search_view": "Less Search view",
    "search_results": "32 Search Results",

    "fedex_international_two_days": "FedEx International Two Days",
    "ups_standard": "UPS Standard",
    "dhl_standard": "DHL Standard",
    "tforce_international_two_days": "TForce International Two Days",
    "fedex_international_two_days_2": "FedEx International Two Days",
    "ups_standard_2": "UPS Standard",
    "dhl_standard_2": "DHL Standard",

    "view_detail": "View Detail",
    "buy_label": "Buy Label",

    "is_this_shipment_time_sensitive": "Is this shipment time-sensitive?",
    "sender_info": "Sender Info",
    "recipient_info": "Recipient Info",
    "package_details": "Package Details",
    "location": "Location",
    "compare_rate_couriers": "Compare Rate Couriers",
    "proceed": "Proceed",

    "select_options": "Select Options",
    "sender_information": "Sender Information",
    "recipient_information": "Recipient Information",
    "date_and_location": "Date & Location",
    "compare_rates": "Compare Rates",
    "payment_successful": "Payment Successful",
    "view_label": "View Label",
    "back_to_home": "Back To Home",
    "payment_successfull": "Payment Successful",

    "when_shipping": "When are you shipping?",
    "search": "search",


    "my_profile": "My Profile",
    "profile_name": "Melanie Roberts",
    "address": "Address",
    "email_address": "Email address",
    "phone_number": "Phone number",

    "notification": "Notification",

    "change_your_password": "Change your password",
    "change_password": "Change Password",
    "current_password": "Current Password",
    "set_new_password": "Set New Password",
    "new_password": "New Password",
    "confirm_password": "Confirm Password",
    "character_long": "At least 12 characters long but 14 or more is better.",
    "password_regex": "A combination of uppercase letters, lowercase letters, numbers, and symbols.",
    "save_and_continue": "Save & Continue",


    "help": "Help",
    "help_title": "How we can help you?",
    "help_description": "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book.",
    "email_us": "Email Us",
    "chat_with_us": "Chat with Us"
}

export default en